<template>
  <b-modal
    id="invoices-payments"
    size="lg"
    :ok-only="true"
    v-model="modalOpen"
    :modal-class="['custom-modal', { 'no-close-icon': loading }]"
  >
    <div v-if="loading" class="text-center text-success my-2">
        <b-spinner class="align-middle"/>
        <strong>Загрузка</strong>
    </div>

    <div v-else>
      <b-card class="custom-card">
        <div class="d-flex align-items-center w-100">
          <h5>Оплаты счёта № {{newItem.numb}}</h5>
          <span :class="['custom-tag ml-auto mr-2', getStatusStyle(newItem.paid_type)]">
            {{ getStatusName(newItem.paid_type) }}
          </span>
          <b-button class="custom-btn-primary" @click.stop="onAddPayment()">
            <v-icon name="buttons/plus" :size="12"/>
            Добавить
          </b-button>
        </div>

        <div class="page-body">
          <template v-if="isBusy || (newItem.payments && newItem.payments.length > 0)">
            <div class="page-table-container">
              <b-table
                id="invoice-payments"
                ref="invoice_payments"
                class="custom-table mb-0"
                selectable
                select-mode="single"
                responsive
                :items="newItem.payments"
                :fields="paymentsFields"
                :per-page="paymentsPerPage"
                :current-page="paymentsCurrentPage"
                :sort-by.sync="paymentsSortBy"
                :sort-desc.sync="paymentsSortDesc"
                no-provider-filtering
                no-provider-paging
                no-provider-sorting
              >
                <template #cell(numb)="row">
                  <b-form-input
                    id="input_number"
                    size="sm"
                    autocomplete="off"
                    v-model.number="row.item.numb"
                  />
                </template>

                <template #cell(date)="row">
                  <b-form-input
                    id="input_date"
                    size="sm"
                    type="date"
                    v-model.date="row.item.date"
                  />
                </template>

                <template #cell(sum)="row">
                  <b-form-input
                    id="input_contract"
                    size="sm"
                    class="widthPrice"
                    autocomplete="off"
                    v-model.number="row.item.sum"
                  />
                </template>

                <template #cell(comment)="row">
                  <b-form-input
                    id="input_town"
                    size="sm"
                    autocomplete="off"
                    v-model="row.item.comment"
                  />
                </template>

                <template #cell(action)="row">
                  <b-btn variant="link" @click="removePayment(row)">
                    <v-icon name="buttons/trash" :size="16"/>
                  </b-btn>
                </template>
              </b-table>
            </div>

            <div class="page-pagination">
              <pagination-footer
                :total-rows="newItem.payments.length"
                :per-page="paymentsPerPage"
                :current-page.sync="paymentsCurrentPage"
                @per-page-change="onPerPageChange"
              >
                <template #footer-list>
                  Всего оплат: <b>{{newItem.payments.length}}</b> |
                  Сумма по оплатам: <b>{{priceFormat(totalPaymentsSum)}}</b>
                </template>
              </pagination-footer>
            </div>
          </template>

          <div v-else class="empty-state-container">
            <v-icon name="navbar/empty_table" :size="90"/>
            <h5>Нет добавленных оплат.</h5>
            <p>Добавьте оплаты в счёт прямо сейчас</p>
            <b-btn class="custom-btn-primary mt-1" @click.stop="onAddPayment()">
              <v-icon name="buttons/plus" :size="12" class="mr-1"/>
              Новая оплата
            </b-btn>
          </div>
        </div>
      </b-card>
    </div>

    <template #modal-footer>
      <b-button v-if="!loading" class="custom-btn-secondary mr-2" @click="hideModal()">
        Отменить
      </b-button>
      <b-button v-if="!loading" class="custom-btn-primary" @click="handleSubmit()">
        Сохранить
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import invoices from "../../network/invoices";
  import helpers from "../../utilites/helpers";
  import dateFormatter from "../../utilites/dateFormatter";
import PaginationFooter from "../../utilites/commonUi/PaginationFooter.vue";

export default {
  name: "InvoicesPayments",
  components: {PaginationFooter},
  mixins: [
    invoices,
    helpers, dateFormatter
  ],
  data() {
    return {
      newItem: {
        id: 0,
        numb: 0,
        date: this.formatDate(new Date()),
        summa: 0,
        active: true,
        paid_type: 0,
        works: [],
        payments: [],
      },
      isBusy: true,
      paymentsFields: [
        {
          key: 'numb',
          label: '№ Оплаты',
          class: 'widthPrice',
          sortable: false,
        },
        {
          key: 'date',
          label: 'Дата',
          class: 'widthCatalog',
          sortable: true,
        },
        {
          key: 'sum',
          label: 'Сумма',
          class: 'widthPrice',
          sortable: false,
        },
        {
          key: 'comment',
          label: 'Комментарий',
          sortable: false,
        },
        {
          key: 'action',
          label: "Действия",
          class: 'widthPrice',
          tdClass: 'align-bottom',
          sortable: false,
        },
      ],
      paidTypes: [
        { id: 0, name: "Не оплачено" },
        { id: 1, name: "Оплачено" },
        { id: 2, name: "Частично оплачено" },
        { id: 3, name: "Переплата"}
      ],
      paymentsPerPage: 10,
      paymentsCurrentPage: 1,
      paymentsSortBy: 'date',
      paymentsSortDesc: true,
      modalOpen: false,
      loading: false
    }
  },
  computed: {
    totalPaymentsSum() {
      return this.newItem.payments
        .map(obj => obj.sum)
        .reduce((acc, current) => acc + current, 0)
    },
  },
  methods: {
    async getInvoice(invoiceId) {
      const result = await this.getInvoiceById(invoiceId);

      if (!result || !result.data) {
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        return;
      }

      this.newItem = result.data;
      let payments = this.newItem.payments;

      payments.forEach(pay => {
        pay.date = this.formatDate(new Date(pay.date));
      });
      this.newItem.payments = payments;
    },
    async handleSubmit() {
      const date = this.formatServerDate(new Date(this.newItem.date));

      let payments = this.newItem.payments;

      payments.forEach(pay => {
        pay.date = this.formatServerDate(new Date(pay.date));
      });

      const taskIds = this.newItem.tasks.map(obj => obj.id);
      const data = {
        id: this.newItem.id,
        date: date,
        summa: this.newItem.summa,
        customer_id: this.newItem.customer_id,
        organization_id: this.newItem.organization_id,
        active: this.newItem.active,
        task_ids: taskIds,
        paid_type: this.newItem.paid_type,
        works: this.newItem.works,
        numb: this.newItem.numb,
        acts: this.newItem.acts,
        payments: payments,
        contract: this.newItem.contract
      }

      const result = await this.putInvoice(data);

      if (!result || !result.data) {
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        return;
      }

      this.newItem.id = result.data.id;
      this.hideModal();
    },
    onAddPayment() {
      const pay = {
        id: 0,
        numb: 0,
        date: this.formatDate(new Date()),
        sum: this.newItem.summa,
        comment: '',
      };
      this.newItem.payments.unshift(pay);
      this.paymentsCurrentPage = 1;
    },
    removePayment(row) {
      if (row.item) {
        this.deleteRow = row.item;
      }
      const title = 'Удаление оплаты';
      const message = `Вы уверены, что хотите удалить оплату № ${this.deleteRow.numb}?`;
      this.showModalDelete(title, message, function () {
        const index = this.newItem.payments.findIndex(item => item === row.item);
        this.newItem.payments.splice(index,1);
      }.bind(this));
    },
    // Status
    updateStatus() {
      if (this.totalPaymentsSum === 0) {
        this.newItem.paid_type = 0;
        return;
      }

      if (this.totalPaymentsSum < this.newItem.summa) {
        this.newItem.paid_type = 2;
        return;
      }

      if (this.totalPaymentsSum === this.newItem.summa) {
        this.newItem.paid_type = 1;
        return;
      }

      if (this.totalPaymentsSum > this.newItem.summa) {
        this.newItem.paid_type = 3;
        return;
      }
    },
    getStatusName(status_id) {
      const status = this.paidTypes.find(e => e.id === status_id)
      return status != null ? status.name : 'Ошибка';
    },
    getStatusStyle(status_id) {
      switch (status_id) {
        case 0:
          return 'tag-primary';
        case 1:
          return 'tag-success';
        case 2:
          return 'tag-warning';
        case 3:
          return 'tag-warning';
        default:
          return '';
      }
    },
    // Modal
    async showPayments(invoice) {
      this.modalOpen = true;
      this.loading = true;

      await this.getInvoice(invoice.id).finally(() => {
        this.loading = false;
      });
    },
    hideModal() {
      this.modalOpen = false;
      this.newItem = null;
      this.$emit ("update", null)
    },
    onPerPageChange(newPerPage) {
      this.paymentsPerPage = Number(newPerPage);
      this.paymentsCurrentPage = 1;
    },
  },
  watch: {
    'newItem.payments': {
      handler: function (newValues, _) {
        if (this.newItem) {
          this.updateStatus();
        }
      },
    deep: true
    }
  }
}
</script>

<style>

.no-close-icon .close {
  display: none;
}

#invoices-payments-pagination {
  margin-bottom: 0;
}

#invoice-payments td {
  text-align: center;
}

#invoice-payments th {
  text-align: center;
  vertical-align: middle;
}

#invoices-payments .modal-body {
  padding: 0;
}

.widthPrice {
  width: 120px;
}
</style>



// WEBPACK FOOTER //
// src/components/Invoices/InvoicesPayments.vue